// Models
import { CompletedJobModel } from '../models/completed-job-model';
import { CompletedJobSearchModel } from '../models/complete-job-search.model';
import { Job } from '../models';

export namespace JobActions {
	export class SetAllCachedJobs {
		static readonly type = '[Job] Set All Cached Jobs';
		constructor(public jobs: Job[]) {}
	}

	export class AddCachedJob {
		static readonly type = '[Job] Add Cached Job';
		constructor(public job: Job) {}
	}

	export class UpdateCachedJob {
		static readonly type = '[Job] Update Cached Job';
		constructor(public job: Job) {}
	}

	export class GetAllActiveJobs {
		static readonly type = '[Job] Get All Active Jobs';
		constructor(
			public showSpinner: boolean = true,
			public showToast: boolean = true
		) {}
	}

	export class SetAllActiveJobs {
		static readonly type = '[Job] Set All Active Jobs';
		constructor(public jobs: Job[]) {}
	}

	export class AddActiveJob {
		static readonly type = '[Job] Add Active Job';
		constructor(public job: Job) {}
	}

	export class UpdateActiveJob {
		static readonly type = '[Job] Update Active Job';
		constructor(public job: Job) {}
	}

	export class RemoveActiveJob {
		static readonly type = '[Job] Remove Active Job';
		constructor(public job: Job) {}
	}

	export class FilterActiveJobs {
		static readonly type = '[Job] Filter Active Jobs';
		constructor(public jobTypeIds: number[]) {}
	}

	export class GetAllCompletedJobs {
		static readonly type = '[Job] Get All Completed Jobs';
		constructor(public data: { searchModel: CompletedJobSearchModel; showSpinner?: boolean; showToast?: boolean } = { searchModel: null, showSpinner: false, showToast: false }) {}
	}

	export class SetAllCompletedJobs {
		static readonly type = '[Job] Set All Completed Jobs';
		constructor(public jobs: CompletedJobModel[]) {}
	}

	export class AddCompletedJob {
		static readonly type = '[Job] Add Completed Job';
		constructor(public job: CompletedJobModel) {}
	}
}
